import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "pl-4 py-4"
};
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col flex-1 w-full h-full bg-white"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "flex justify-between pb-6"
};
const _hoisted_6 = {
  class: "w-2/12 pl-2"
};
const _hoisted_7 = {
  class: "text-center"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
import { onMounted, reactive, ref, computed } from 'vue';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import UpdateInvoiceTemplateModal from './UpdateInvoiceTemplateModal.vue';
import InvoiceTemplateListTable from '../InvoiceTemplateListTable.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
import RouteService from '@/services/RouteService';
import { useMeStore } from '@/services/UserService/useMeStore';
import UpgradeDialog from '@/components/UpgradeDialog.vue';
import EventTracker from '@/services/eventTracker';
export default {
  __name: 'InvoicePdf',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      features,
      me,
      company
    } = storeToRefs(useMeStore());
    const {
      getMe
    } = useMeStore();
    const {
      invoiceTemplateLists
    } = storeToRefs(useInvoiceTemplateStore());
    const props = __props;
    const invoiceTemplateStore = useInvoiceTemplateStore();
    invoiceTemplateStore.alerts = props.alerts;
    const upgradeModel = ref(undefined);
    const routeService = new RouteService(props);
    const trackEvent = (category, action, additionalData = {}) => {
      EventTracker.trackEvent(props.tracking, category, action, {
        companyName: company.value.name,
        email: me.value.email,
        companyId: company.value.id,
        ...additionalData
      });
    };
    const invoicePdf = reactive({
      loading: false,
      invoicePdfNotSet: true,
      items: [{
        title: 'Set as Default',
        id: 'setAsDefault'
      }, {
        title: 'Edit',
        id: 'edit'
      }, {
        title: 'Duplicate',
        id: 'duplicate'
      }, {
        title: 'Delete',
        id: 'delete'
      }],
      selectedInvoiceTemplate: '',
      featureEnabled: false
    });
    onMounted(async () => {
      fetchInvoiceTemplates();
      await getMe();
    });
    const updateInvoiceTemplate = invoiceTemplateId => {
      invoicePdf.showEditInvoiceTemplate = true;
      invoicePdf.selectedInvoiceTemplate = invoiceTemplateId;

      // Track Invoice Template Opened event
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, 'Invoice Template', 'Opened', {
          templateId: invoiceTemplateId
        });
      }
    };
    const setAsDefaultTemplate = async invoiceTemplateId => {
      invoicePdf.loading = true;
      try {
        await invoiceTemplateStore.setDefaultTemplate(invoiceTemplateId);
        await fetchInvoiceTemplates();
      } catch (error) {
        props.alerts.error('Error setting default invoice template');
      } finally {
        invoicePdf.loading = false;
      }
    };
    const deleteInvoiceTemplate = async (invoiceTemplateId, invoiceTemplate) => {
      if (invoiceTemplate.default) {
        props.alerts.error('Default invoice template cannot be deleted');
        return;
      }
      invoicePdf.loading = true;
      try {
        await invoiceTemplateStore.deleteTemplate(invoiceTemplateId);
        await fetchInvoiceTemplates();
      } catch (error) {
        props.alerts.error(error);
      } finally {
        invoicePdf.loading = false;
      }
    };
    const currentSubscription = computed(() => {
      if (!company.value?.products) return null;
      const products = company.value.products;
      if (products.trial) return 'trial';
      if (products.pro) return 'pro';
      if (products.core) return 'core';
      if (products.accountant) return 'accountant';
      return 'none';
    });
    const duplicateInvoiceTemplate = async invoiceTemplateId => {
      if (hasReachedMaxTemplate()) {
        trackEvent('Template Limit Upgrade Path', 'Triggered', {
          subscription: currentSubscription.value
        });
        showUpgradeModal();
        return;
      }
      invoicePdf.loading = true;
      try {
        const result = await invoiceTemplateStore.duplicateTemplate(invoiceTemplateId);
        trackEvent('Template', 'Created', {
          duplicate: true,
          invoiceTemplateId: result.invoiceTemplateId
        });
        await fetchInvoiceTemplates();
      } catch (error) {
        props.alerts.error(error);
      } finally {
        invoicePdf.loading = false;
      }
    };
    const handleActionButtonClicked = (action, invoiceTemplateId, invoiceTemplate) => {
      switch (action) {
        case 'setAsDefault':
          setAsDefaultTemplate(invoiceTemplateId);
          break;
        case 'edit':
          updateInvoiceTemplate(invoiceTemplateId);
          break;
        case 'duplicate':
          duplicateInvoiceTemplate(invoiceTemplateId);
          break;
        case 'delete':
          deleteInvoiceTemplate(invoiceTemplateId, invoiceTemplate);
          break;
        default:
          break;
      }
    };
    const fetchInvoiceTemplates = async () => {
      invoicePdf.loading = true;
      try {
        await invoiceTemplateStore.getTemplates();
      } catch (error) {
        props.alerts.error('Error fetching invoice templates');
      } finally {
        invoicePdf.loading = false;
      }
    };
    const closeModelAndFetchInvoiceTemplates = reload => {
      if (!reload && invoicePdf.selectedInvoiceTemplate) {
        trackEvent('Template Update', 'Abandoned', {
          InvoiceTemplateId: invoicePdf.selectedInvoiceTemplate
        });
      }
      invoicePdf.showEditInvoiceTemplate = false;
      invoicePdf.selectedInvoiceTemplate = '';
      if (reload) fetchInvoiceTemplates();
    };
    const hasReachedMaxTemplate = () => {
      if (features.value.templatesUnlimited) {
        return false;
      }
      if (features.value.templates3) {
        return invoiceTemplateLists.value.length >= 3;
      }
      return invoiceTemplateLists.value.length >= 1;
    };
    const createInvoiceTemplate = () => {
      if (hasReachedMaxTemplate()) {
        trackEvent('Template Limit Upgrade Path', 'Triggered', {
          subscription: currentSubscription.value
        });
        return;
      }
      invoicePdf.showEditInvoiceTemplate = true;

      // Track Invoice Template Opened event for new template creation
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, 'Invoice Template', 'Opened', {
          templateId: 'new'
        });
      }
    };
    const goToSubscription = () => {
      routeService.go('settings.company.maxioCompanySubscription');
    };
    const showUpgradeModal = () => {
      upgradeModel.value.open().then(async result => {
        if (result) {
          if (features.value.templates3) {
            const sent = await invoiceTemplateStore.requestEliteUpgrade();
            if (sent) {
              props.alerts.success("We've let our Success team know you're interested in upgrading.");
            }
          } else {
            routeService.go('settings.company.maxioCompanySubscription');
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [invoicePdf.loading ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 0,
        type: "card,table-row"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_dialog, {
        modelValue: invoicePdf.showEditInvoiceTemplate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => invoicePdf.showEditInvoiceTemplate = $event),
        class: "w-11/12"
      }, {
        default: _withCtx(() => [_createVNode(UpdateInvoiceTemplateModal, {
          alerts: __props.alerts,
          state: __props.state,
          tracking: __props.tracking,
          leanLawAuth: __props.leanLawAuth,
          selectedInvoiceTemplate: invoicePdf.selectedInvoiceTemplate,
          onCloseDialog: closeModelAndFetchInvoiceTemplates
        }, null, 8, ["alerts", "state", "tracking", "leanLawAuth", "selectedInvoiceTemplate"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(UpgradeDialog, {
        ref_key: "upgradeModel",
        ref: upgradeModel,
        title: _unref(features).templates3 ? 'Upgrade to Elite' : 'Upgrade to Pro',
        "confirm-text": _unref(features).templates3 ? 'Contact Success to Upgrade' : 'Upgrade',
        "toggle-text": "Cancel"
      }, {
        message: _withCtx(() => [_unref(features).templates3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [_createTextVNode(" You've reached your limit of 3 invoice templates. Upgrade to Elite for unlimited custom templates and more. See the full list of Elite perks ", -1), _createElementVNode("a", {
          href: "https://www.leanlaw.co/pricing/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "here.", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [_createTextVNode(" You've reached your limit of 1 invoice template. Upgrade to Pro for 2 additional templates and other features. See the full list of Pro perks ", -1), _createElementVNode("a", {
          href: "https://www.leanlaw.co/pricing/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "here.", -1)]))]))]),
        _: 1
      }, 8, ["title", "confirm-text"]), _createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "w-10/12 pr-2"
      }, " Customize your invoices so that you are presenting the best version of your firm to your clients. Choose what information you want to show on your invoice and how you summarize the information so you provide a clear, professional invoice to your clients. We will still send the invoice information to QuickBooks Online, but your invoices will be created and sent through LeanLaw. ", -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_v_menu, {
        "open-on-hover": "",
        location: "bottom"
      }, {
        activator: _withCtx(({
          props
        }) => [_createVNode(LlSecondaryButton, _mergeProps(props, {
          "prepend-icon": "mdi-plus",
          color: hasReachedMaxTemplate() ? 'grey-lighten-1' : 'primary',
          "data-cy": "new-template",
          onBtnClick: _cache[1] || (_cache[1] = $event => createInvoiceTemplate())
        }), {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" New Template ", -1)]))]),
          _: 1
        }, 16, ["color"])]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_v_card, {
          width: "250"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_unref(features).templates3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " You have reached your maximum number of templates. Email success@myleanlaw.com to upgrade to Elite and get access to unlimited templates. ")) : (_openBlock(), _createElementBlock("div", _hoisted_9, " You have reached your maximum number of templates. Upgrade to Pro and get two additional custom templates. "))]),
            _: 1
          }), !_unref(features).templates3 ? (_openBlock(), _createBlock(_component_v_card_actions, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              variant: "text",
              onClick: _cache[2] || (_cache[2] = $event => goToSubscription())
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Upgrade ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_spacer)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 512), [[_vShow, hasReachedMaxTemplate()]])]),
        _: 1
      })])])]), _createVNode(InvoiceTemplateListTable, {
        invoiceTemplateLists: _unref(invoiceTemplateLists),
        items: invoicePdf.items,
        onUpdateInvoiceTemplate: updateInvoiceTemplate,
        onHandleActionButtonClicked: handleActionButtonClicked
      }, null, 8, ["invoiceTemplateLists", "items"])]))]);
    };
  }
};